import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/ApiEndpoints";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

// Country - Get All
export const getAllCountries = createAsyncThunk(
  "master/getAllCountries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllCountry);
      return await Select2Data(response.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllRoles = createAsyncThunk(
  "master/getAllRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllRoles);
      return await Select2Data(response.data.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//shows the state after adding country
// export const getAllStates = createAsyncThunk(
//   "master/getAllStates",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await GET(APIS.Commons.AllStates + `/${id}`);
//       const data = await Select2Data(response.data?.data, "state_id");
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const getAllStates = createAsyncThunk(
  "common/getAllStates",
  async (payload, { rejectWithValue }) => {
    try {
      // Handle both: if payload is a number/string OR an object
      let countryId = "";
      let name = "";

      if (typeof payload === "object") {
        countryId = payload.countryId || "";
        name = payload.name || "";
      } else {
        countryId = payload;
      }

      const url = name
        ? `${APIS.Commons.AllStates}/${countryId}?name=${name}`
        : `${APIS.Commons.AllStates}/${countryId}`;

      const response = await GET(url);
      return await Select2Data(response.data?.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//works in filter
// State - Get All (for a specific country)
// export const getAllStates = createAsyncThunk(
//   "common/masters/all-state/:id",
//   async ({ countryId, name = "" }, { rejectWithValue }) => {
//     try {
//       const res = await GET(
//         `${APIS.Commons.AllStates}/${countryId}?name=${name}`
//       );

//       // You can adjust Select2Data if necessary
//       return await Select2Data(res.data.data, "state_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

//show only adding city
// export const getAllCities = createAsyncThunk(
//   "master/getAllCities",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await GET(APIS.Commons.AllCities + `/${id}`);
//       const data = await Select2Data(response.data?.data, "city_id");
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// Works in Add Form
export const getAllCities = createAsyncThunk(
  "master/getAllCities",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllCities + `/${id || 1}`);
      const data = await Select2Data(response.data?.data, "city_id");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllCitiesWithoutType = createAsyncThunk(
  "master/getAllCitiesWithoutType",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllCities);
      const data = await Select2Data(response.data?.data, "city_id");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// City - Get All (for a specific state)
// export const getAllCities = createAsyncThunk(
//   "common/masters/all-city/:id",
//   async ({ stateId, name = "" }, { rejectWithValue }) => {
//     try {
//       const res = await GET(`${APIS.Commons.AllCities}/${stateId}?name=${name}`);
//       return await Select2Data(res.data.data, "city_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// Pincode - Get All (for a specific city)
export const getAllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincodes}/${cityId}?name=${name}`,
      );
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllModels = createAsyncThunk(
  "master/getAllModels",
  async (id, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllModels + `/${id}`);
      const data = await Select2Data(response.data?.data, "model_id");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllGender = createAsyncThunk(
  "master/getAllGender",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllGender);
      const data = await Select2Data(response.data?.data, "gender_id");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllVehicleCatWithoutType = createAsyncThunk(
  "master/getAllVehicleCategorywithoutType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllVehicleCategorywithouttype);
      const data = await Select2Data(
        response.data?.data,
        "vehicle_category_id",
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllVehicleCategory = createAsyncThunk(
  "master/getAllVehicleCategory",
  async (type, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllVehicleCategory + `/${type}`);
      const data = await Select2Data(
        response.data?.data,
        "vehicle_category_id",
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getAllVehicleType = createAsyncThunk(
  "master/getAllVehicleType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(APIS.Commons.AllVehicleType);

      const data = await Select2Data(response?.data?.data, "vehicle_type_id");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_states: [],
    all_cities: [],
    all_cities_without_type: [],
    all_pincodes: [],
    all_models: [],
    all_gender: [],
    all_vehicle_category: [],
    all_vehicle_category_without_type: [],
    all_vehicle_type: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllRoles.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_roles = action.payload || [];
      })
      .addCase(getAllRoles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllCountries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_country = action.payload || [];
      })
      .addCase(getAllCountries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllStates.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllStates.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_states = action.payload || [];
      })
      .addCase(getAllStates.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllCities.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllCities.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_cities = action.payload || [];
      })
      .addCase(getAllCities.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllCitiesWithoutType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllCitiesWithoutType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_cities_without_type = action.payload || [];
      })
      .addCase(getAllCitiesWithoutType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(getAllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getAllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincodes = action.payload || [];
      })
      .addCase(getAllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getAllGender.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllGender.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_gender = action.payload || [];
      })
      .addCase(getAllGender.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllVehicleCategory.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllVehicleCategory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_vehicle_category = action.payload || [];
      })
      .addCase(getAllVehicleCategory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllVehicleCatWithoutType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllVehicleCatWithoutType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_vehicle_category_without_type = action.payload || [];
      })
      .addCase(getAllVehicleCatWithoutType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllModels.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllModels.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_models = action.payload || [];
      })
      .addCase(getAllModels.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getAllVehicleType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAllVehicleType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_vehicle_type = action.payload || [];
      })
      .addCase(getAllVehicleType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
